// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_l2-0";
export var buttonContainer = "_l2-3";
export var cancelButton = "_l2-4";
export var headerSection = "_l2-6";
export var headerTitle = "_l2-9";
export var messageSideLeft = "_l2-1";
export var messageSideRight = "_l2-2";
export var orderNumberContainer = "_l2-7";
export var orderNumberLabel = "_l2-8";
export var submitButton = "_l2-5";